'use client';

import { type ReactElement, useId } from 'react';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { cn } from '@/lib/utils';
import type { PlpSortingOption } from '@/components/eataly-category-plp-sticky-bar';

export interface EatalyPlpOrdinationOptionsProps {
    sortingOptions: PlpSortingOption[];
    effectiveSortingOption: string | undefined;
    isPending: boolean;
    onSelectSort: (sortId: string) => void;
    ariaLabel: string;
    className?: string;
    idPrefix?: string;
}

export default function EatalyPlpOrdinationOptions({
    sortingOptions,
    effectiveSortingOption,
    isPending,
    onSelectSort,
    ariaLabel,
    className,
    idPrefix: idPrefixProp,
}: EatalyPlpOrdinationOptionsProps): ReactElement {
    const generatedIdPrefix = useId();
    const idPrefix = idPrefixProp ?? `ordination-${generatedIdPrefix}`;

    return (
        <RadioGroup
            value={effectiveSortingOption}
            onValueChange={onSelectSort}
            aria-label={ariaLabel}
            className={cn('flex flex-col gap-4', isPending && 'pointer-events-none opacity-50', className)}>
            {sortingOptions.map((option) => (
                <label
                    key={option.id}
                    htmlFor={`${idPrefix}-${option.id}`}
                    className="flex w-full cursor-pointer items-center gap-2 rounded-sm has-[:focus-visible]:outline-solid has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-2 has-[:focus-visible]:outline-ring">
                    <span className="flex size-6 shrink-0 items-center justify-center p-1">
                        <RadioGroupItem value={option.id} id={`${idPrefix}-${option.id}`} className="shrink-0" />
                    </span>
                    <span className="body-copy-m min-w-0 flex-1 text-left text-neutral-10">{option.label}</span>
                </label>
            ))}
        </RadioGroup>
    );
}
